<template>
  <v-layout row>
    <v-flex 
      sm12 
      md8 
      offset-md2
      xl6
      offset-xl3>
      <v-card>
        <v-card-text>
          <v-container grid-list-sm >
            <v-layout 
              row 
              wrap>
              <v-flex 
                xs6 
                md3>
                <v-autocomplete
                  v-model="queryParams.uid"
                  :items="students"
                  :loading="studentsLoading"
                  :search-input.sync="searchStudent"
                  :class="{'grey lighten-3':queryParams.uid}"
                  color="primary"
                  hide-no-data
                  hide-selected
                  clearable
                  item-text="codename"
                  item-value="code"
                  label="Student"
                  prepend-inner-icon="search"
                  hint ="Find by name or username."
                />
              </v-flex>
              <v-flex 
                xs6 
                md3>
                <v-text-field
                  v-model="queryParams.studentId"
                  :class="{'grey lighten-3':queryParams.studentId}"
                  label="Student number"
                  hint="Exact matches only"
                />
              </v-flex>              
              <v-flex 
                v-if="this.userType !== 'Organisation'"
                xs6 
                md3>
                <v-select
                  v-model="queryParams.campus"
                  :items="['Burwood', 'Waterfront', 'Warrnambool', 'Waurn Ponds', 'Cloud']"
                  :class="{'grey lighten-3':queryParams.campus}"
                  clearable
                  label="Campus"                       
                />
              </v-flex>
              <v-flex 
                xs6 
                md3>
                <v-autocomplete
                  v-model="queryParams.course"
                  :items="courses"
                  :loading="coursesLoading"
                  :search-input.sync="searchCourse"
                  :class="{'grey lighten-3':queryParams.course}"
                  color="primary"
                  hide-no-data
                  hide-selected
                  clearable
                  item-text="codename"
                  item-value="code"
                  label="Course"
                  prepend-inner-icon="search"
                />
              </v-flex>
              <v-flex 
                xs6 
                md3>
                <v-autocomplete
                  v-model="queryParams.unit"
                  :items="units"
                  :loading="unitsLoading"
                  :search-input.sync="searchUnit"
                  :class="{'grey lighten-3':queryParams.unit}"
                  color="primary"
                  hide-no-data
                  hide-selected
                  clearable
                  item-text="codename"
                  item-value="code"
                  label="Unit"
                  prepend-inner-icon="search"
                />
              </v-flex>
              <v-flex 
                v-if="this.userType !== 'Organisation'"
                xs6 
                md3>
                <v-autocomplete
                  v-model="queryParams.organisation"
                  :items="organisations"
                  :loading="organisationsLoading"
                  :search-input.sync="searchOrganisation"
                  :class="{'grey lighten-3':queryParams.organisation}"
                  color="primary"
                  hide-no-data
                  hide-selected
                  clearable
                  item-text="name"
                  item-value="code"
                  label="Organisation"
                  prepend-inner-icon="search"
                />
              </v-flex>
              <v-flex 
                xs6 
                md3>
                <v-text-field
                  v-model="queryParams.step"
                  :class="{'grey lighten-3':queryParams.step}"
                  label="Step number"
                  type="number"
                />
              </v-flex>
              <v-flex 
                xs6 
                md3>
                <v-select
                  v-model="queryParams.type"
                  :items="['Student', 'Organisation', 'Staff', 'Academic']"
                  :class="{'grey lighten-3':queryParams.type}"
                  clearable
                  label="Step type"                       
                />
              </v-flex>
              <v-flex 
                xs6 
                md3>
                <v-select
                  v-model="queryParams.order"
                  :items="['lastUpdate']"
                  :class="{'grey lighten-3':queryParams.order}"
                  label="Order"
                />
              </v-flex>
              <v-flex 
                xs6 
                md3>
                <v-select
                  v-model="queryParams.sort"
                  :items="['asc', 'desc']"
                  :class="{'grey lighten-3':queryParams.sort}"
                  label="Sort"
                />
              </v-flex>
              <v-flex 
                v-if="this.userType !== 'Organisation'"
                xs6 
                md3>
                <v-select
                  :items="years"
                  v-model="queryParams.year"
                  :class="{'grey lighten-3':queryParams.year}"
                  item-text="year"  
                  item-value="year" 
                  label="Completed"    
                  clearable          
                />
              </v-flex>
            </v-layout>
            <v-layout 
              row 
              wrap>
              <v-spacer/>
              <v-flex 
                xs6 
                md3>
                <v-btn 
                  color="primary" 
                  flat
                  block
                  @click="changeFilter">Search</v-btn>
              </v-flex>
              <v-flex 
                v-if="this.userType !== 'Organisation'"
                xs6 
                md3>
                <v-btn 
                  color="primary" 
                  flat
                  block
                  @click="csvGenerator">CSV</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-toolbar 
          color="primary" 
          dark>
          <v-toolbar-title>Placement List</v-toolbar-title>
        </v-toolbar>
        <v-list 
          three-line 
          subheader>
          <v-list-tile 
            v-for="item in placements" 
            :key="item['.key']" 
            :to="{path: $route.path + '/' + item.uid, query: {key: item['.key']}}"
            :class="item.nextStepType === userType ? 'grey lighten-4' : ''"
          >
            <v-list-tile-content>
              <v-list-tile-title>{{ item.displayName }} [{{ item.studentId }}] <span class="caption grey--text text--darken-1">{{ item.organisationName }}</span></v-list-tile-title>
              <v-list-tile-sub-title class="text--primary">
                {{ item.unit + ': ' + item.unitName }} 
                <span class="caption grey--text text--darken-1">{{ item.campus }}</span>
              </v-list-tile-sub-title>
              <v-list-tile-sub-title>{{ item.organisationName }} {{ item.startDate | moment("L") }} - {{ item.endDate | moment("L") }}</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-content 
              class="hidden-xs-only"
              v-if="standardArray(item).length > 0">
              <v-tooltip bottom>
                <v-list-tile-sub-title slot="activator"> 
                  <span 
                    v-for="(standard, index) in standardArray(item)"
                    :key=" index">
                    <v-chip 
                      v-if="standard && standard.count > 0"                    
                      :color="standard.color" 
                      text-color="white">
                      {{ standard.count }}
                      <v-icon right>{{ standard.icon }}</v-icon>
                    </v-chip>     
                  </span>                          
                </v-list-tile-sub-title>
                <span>Standard results</span>
              </v-tooltip>
            </v-list-tile-content>
            <v-list-tile-action class="hidden-xs-only">
              <v-tooltip bottom>
                <v-chip 
                  slot="activator"
                  color="light-blue" 
                  text-color="white">
                  <v-avatar 
                    left 
                    class="blue darken-4">{{ item.step }}</v-avatar>
                  {{ item.nextStep }}
                </v-chip>
                <span>Current step</span>
              </v-tooltip>
              <span class="caption grey--text text--darken-1">Last update: {{ item.lastUpdate.seconds | moment("calendar") }}</span>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
        <infinite-loading 
          :identifier="infiniteId"
          @infinite="infiniteHandler">
          <span slot="no-more">
            There are no more placements
          </span>
        </infinite-loading>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import Json2csvParser from "json2csv";

export default {
  name: "Courses",
  components: {
    InfiniteLoading,
    Json2csvParser
  },
  props: {
    userType: {
      type: String,
      default: null
    }
  },
  data: () => ({
    hidden: false,
    dialog: false,
    valid: true,
    placementCSV: [],
    // InfiniteLoader
    placements: [],
    lastVisible: null,
    infiniteId: +new Date(),
    runningQuery: false,
    queryParams: {
      uid: null,
      studentId: null,
      displayName: null,
      campus: null,
      course: null,
      unit: null,
      organisation: null,
      step: null,
      type: null,
      order: "lastUpdate",
      sort: "desc"
    },
    // Typeaheads
    searchUnit: null,
    units: [],
    unitsLoading: false,
    searchCourse: null,
    courses: [],
    coursesLoading: false,
    searchOrganisation: null,
    organisations: [],
    organisationsLoading: false,
    searchStudent: null,
    students: [],
    studentsLoading: false
  }),
  computed: {
    user() {
      return this.$store.getters.user;
    },
    loading() {
      return this.$store.getters.loading;
    }
  },
  firestore() {
    return {
      /*organisations: this.$store.getters.db
        .collection("roles/organisation/users")
        .orderBy("fullname"),*/
      years: this.$store.getters.db.collection("completed").orderBy("year")
    };
  },
  watch: {
    searchUnit(val) {
      // Items have already been loaded
      // if (this.items.length > 0) return;
      // Value not set
      if (!val) return;
      if (
        this.units.find(element => {
          return element.codename === val;
        })
      )
        return;

      // Items have already been requested
      // if (this.unitsLoading) return;

      this.unitsLoading = true;
      //this.$store.dispatch("setLoading", true);

      this.$store.getters.db
        .collection("typeahead/units/indexes")
        //.where("searchableIndex." + val.toLowerCase(), "==", true)
        .orderBy("searchableIndex." + val.toLowerCase())
        .limit(10)
        .get()
        .then(snapshot => {
          this.units = snapshot.docs.map(doc => {
            return {
              name: doc.data().name,
              codename: doc.data().code + " " + doc.data().name,
              code: doc.data().code
            };
          });
        })
        .finally(() => (this.unitsLoading = false));
    },
    searchCourse(val) {
      if (!val) return;
      if (
        this.courses.find(element => {
          return element.codename === val;
        })
      )
        return;
      this.coursesLoading = true;
      this.$store.getters.db
        .collection("typeahead/courses/indexes")
        .orderBy("searchableIndex." + val.toLowerCase())
        .limit(10)
        .get()
        .then(snapshot => {
          this.courses = snapshot.docs.map(doc => {
            return {
              name: doc.data().name,
              codename: doc.data().code + " " + doc.data().name,
              code: doc.data().code
            };
          });
        })
        .finally(() => (this.coursesLoading = false));
    },
    searchOrganisation(val) {
      if (!val) return;
      if (
        this.courses.find(element => {
          return element.codename === val;
        })
      )
        return;
      this.organisationsLoading = true;
      this.$store.getters.db
        .collection("typeahead/organisations/indexes")
        .orderBy("searchableIndex." + val.toLowerCase())
        .limit(10)
        .get()
        .then(snapshot => {
          this.organisations = snapshot.docs.map(doc => {
            return {
              name: doc.data().name,
              codename: doc.data().code + " " + doc.data().name,
              code: doc.data().code
            };
          });
        })
        .finally(() => (this.organisationsLoading = false));
    },
    searchStudent(val) {
      if (!val) return;
      if (
        this.students.find(element => {
          return element.codename === val;
        })
      )
        return;
      this.studentsLoading = true;
      this.$store.getters.db
        .collection("students")
        .orderBy("searchableIndex." + val.toLowerCase())
        .limit(10)
        .get()
        .then(snapshot => {
          this.students = snapshot.docs.map(doc => {
            return {
              name: doc.data().name,
              codename: doc.data().name + " (" + doc.data().uid + ")",
              code: doc.data().uid
            };
          });
        })
        .finally(() => (this.studentsLoading = false));
    }
  },
  methods: {
    standardArray(placement) {
      let success = { color: "success", icon: "check_circle", count: 0 };
      let warning = { color: "warning", icon: "info", count: 0 };
      let error = { color: "error", icon: "error", count: 0 };
      if (placement && placement.standardResults) {
        Object.keys(placement.standardResults).forEach(key => {
          success.count += placement.standardResults[key].success;
          warning.count += placement.standardResults[key].warning;
          error.count += placement.standardResults[key].error;
        });
        // Return empty array if no count values found
        if (success.count || warning.count || error.count) {
          return [success, warning, error];
        } else {
          return [];
        }
      } else {
        return [];
      }
    },
    infiniteHandler($state) {
      this.$store.dispatch("setLoading", true);

      if (this.lastVisible === undefined) {
        $state.complete();
        this.$store.dispatch("setLoading", false);
        return;
      }

      if (this.runningQuery) {
        return;
      }
      this.runningQuery = true;

      let loadPlacements =
        this.userType === "Organisation"
          ? this.$store.getters.db.collection(
              `organisation/${this.user.uid}/placements`
            )
          : this.queryParams.year
            ? this.$store.getters.db.collection(
                "completed/" + this.queryParams.year + "/placements"
              )
            : this.$store.getters.db.collection("placements");

      let query = loadPlacements;
      query = this.queryParams.uid
        ? query.where("uid", "==", this.queryParams.uid)
        : query;
      query = this.queryParams.studentId
        ? query.where("studentId", "==", this.queryParams.studentId)
        : query;
      /*query = this.queryParams.displayName
        ? query.where("displayName", "==", this.queryParams.displayName)
        : query;*/
      query = this.queryParams.campus
        ? query.where("campus", "==", this.queryParams.campus)
        : query;
      query = this.queryParams.course
        ? query.where("course", "==", this.queryParams.course)
        : query;
      query = this.queryParams.unit
        ? query.where("unit", "==", this.queryParams.unit)
        : query;
      query = this.queryParams.organisation
        ? query.where("organisation", "==", this.queryParams.organisation)
        : query;
      query = this.queryParams.step
        ? query.where("step", "==", parseInt(this.queryParams.step))
        : query;
      query = this.queryParams.type
        ? query.where("nextStepType", "==", this.queryParams.type)
        : query;
      // more query options

      query = query.orderBy(this.queryParams.order, this.queryParams.sort);
      query = this.lastVisible ? query.startAfter(this.lastVisible) : query;
      query = query.limit(10);

      query.get().then(snapshot => {
        this.lastVisible = snapshot.docs[snapshot.docs.length - 1];
        snapshot.forEach(doc => {
          this.placements.push({ ".key": doc.id, ...doc.data() });
        });
        $state.loaded();
        this.$store.dispatch("setLoading", false);
        this.runningQuery = false;
        // self.placements = snapshot.docs.map(doc => ({__id: doc.id, ...doc.data()}))
      });
    },
    changeFilter() {
      this.lastVisible = null;
      this.placements = [];
      this.infiniteId += 1;
      /*this.$nextTick(() => {
        this.$refs.infiniteLoading.$emit("$InfiniteLoading:reset");
      });*/
    },
    csvGenerator() {
      //let self = this;
      this.$store.dispatch("setLoading", true);

      let loadPlacements = this.queryParams.year
        ? this.$store.getters.db.collection(
            "completed/" + this.queryParams.year + "/placements"
          )
        : this.$store.getters.db.collection("placements");

      let query = loadPlacements;
      query = this.queryParams.uid
        ? query.where("uid", "==", this.queryParams.uid)
        : query;
      query = this.queryParams.studentId
        ? query.where("studentId", "==", this.queryParams.studentId)
        : query;
      /*query = this.queryParams.displayName
        ? query.where("displayName", "==", this.queryParams.displayName)
        : query;*/
      query = this.queryParams.campus
        ? query.where("campus", "==", this.queryParams.campus)
        : query;
      query = this.queryParams.course
        ? query.where("course", "==", this.queryParams.course)
        : query;
      query = this.queryParams.unit
        ? query.where("unit", "==", this.queryParams.unit)
        : query;
      query = this.queryParams.organisation
        ? query.where("organisation", "==", this.queryParams.organisation)
        : query;
      query = this.queryParams.step
        ? query.where("step", "==", parseInt(this.queryParams.step))
        : query;
      query = this.queryParams.type
        ? query.where("nextStepType", "==", this.queryParams.type)
        : query;
      // more query options

      query = query.orderBy(this.queryParams.order, this.queryParams.sort);
      //query = this.lastVisible ? query.startAfter(this.lastVisible) : query;
      //query = query.limit(5);

      query.get().then(snapshot => {
        return Promise.all(
          snapshot.docs.map(doc => {
            let placement = {
              "0-0-0": { label: "Student name", value: doc.data().displayName },
              "0-0-1": { label: "Student number", value: doc.data().studentId },
              "0-0-2": { label: "Student email", value: doc.data().email },
              "0-0-3": { label: "Course code", value: doc.data().course },
              "0-0-4": { label: "Course name", value: doc.data().courseName },
              "0-0-5": { label: "Unit code", value: doc.data().unit },
              "0-0-6": { label: "Unit name", value: doc.data().unitName },
              "0-0-7": { label: "Start date", value: doc.data().startDate },
              "0-0-8": { label: "End date", value: doc.data().endDate },
              "0-0-9": {
                label: "Organisation",
                value: doc.data().organisationName
              }
            };
            return this.$store.getters.db
              .collection("students")
              .doc(doc.data().uid)
              .collection("placements")
              .doc(doc.id)
              .collection("steps")
              .orderBy("itemOrder")
              .get()
              .then(snapshot => {
                snapshot.docs.forEach(item => {
                  if (item.data().formData) {
                    item.data().formData.forEach(block => {
                      if (block.csv) {
                        placement[block.csvKey] = {
                          label: block.csvKey,
                          value:
                            block.value === null
                              ? ""
                              : block.type === "standardblock"
                                ? block.options[block.value].label
                                : block.value
                        };
                      }
                    });
                  }
                });
                return placement;
              });
          })
        ).then(placements => {
          // console.log(placements);
          this.$store.dispatch("setLoading", false);
          let fields = [];
          placements.forEach(placement => {
            Object.keys(placement).forEach(key => {
              // Check for duplicate keys
              let keyCheck = {
                label: placement[key].label,
                value: key + ".value"
              };
              let duplicate = false;
              fields.forEach(entry => {
                if (entry.label == keyCheck.label) {
                  duplicate = true;
                }
              });
              if (!duplicate) {
                fields.push(keyCheck);
              }
            });
          });
          // console.log(fields);

          const csv = Json2csvParser.parse(placements, {
            fields: fields
          });
          // console.log(csv);

          var downloadLink = document.createElement("a");
          var blob = new Blob(["\ufeff", csv]);
          var url = URL.createObjectURL(blob);
          downloadLink.href = url;
          downloadLink.download = "data.csv";

          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        });
      });
    }
  }
};
</script>
